export default __webpack_public_path__ + "static/media/peixe.3e792522.jpg";